import React from "react";
import AsiaPayoutOrchestrator from "../../shared/AsiaPayoutOrchestrator";
import { indonesiaConfig } from "./config";

const IndonesiaPayout: React.FC = () => {
  return <AsiaPayoutOrchestrator config={indonesiaConfig} />;
};

export default IndonesiaPayout;
